<ul [ngClass]="{ 'm-y-0': !darkTheme }">
  <li>
    <i class="icon icon-Share has-text-grey"></i>
  </li>
  <li>
    <a
      class="share-link"
      href="https://www.linkedin.com/shareArticle?mini=true&url={{
        url
      }}&title={{ title }}"
      target="_blank"
    >
      <img
        src="./assets/images/linkedin.svg"
        alt="LinkedIn logo"
        *ngIf="darkTheme"
      />
      <img
        src="./assets/images/linkedin-black.svg"
        alt="LinkedIn logo"
        *ngIf="!darkTheme"
      />
    </a>
  </li>
  <li>
    <a
      class="share-link"
      href="https://twitter.com/share?url={{ url }}&amp;text={{
        title
      }}&amp;hashtags=OECD"
      target="_blank"
    >
      <img
        src="./assets/images/twitter.svg"
        alt="Twitter logo"
        *ngIf="darkTheme"
      />
      <img
        src="./assets/images/twitter-black.svg"
        alt="Twitter logo"
        *ngIf="!darkTheme"
      />
    </a>
  </li>
  <li>
    <a
      class="share-link"
      href="https://www.facebook.com/sharer/sharer.php?u={{ url }}"
      target="_blank"
    >
      <img
        src="./assets/images/facebook.svg"
        alt="Facebook logo"
        *ngIf="darkTheme"
      />
      <img
        src="./assets/images/facebook-black.svg"
        alt="Facebook logo"
        *ngIf="!darkTheme"
      />
    </a>
  </li>
</ul>
